import Vue from "vue";
import Vuex from "vuex";
import api from "./api";
import client from "./client";
import createPersistedState from "vuex-persistedstate";

const AUTH_TOKEN = "AUTH-TOKEN";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    cart_items: [],
    cart_total: 0,
    current_customer: {
      id: "",
      name: "",
      email: "",
      contact: "",
      addresses: [],
    },
    delivery_charges: 0,
    restaurant: {},
    auth_token: localStorage.getItem(AUTH_TOKEN) || null,
  },

  getters: {
    logged_in(state) {
      return state.auth_token !== null
    },
    cart_items_count(state) {
      return state.cart_items.length
    },
    delivery_charges(state) {
      return state.delivery_charges
    },
    cart_total(state) {
      return state.cart_total
    },
    current_customer(state) {
      return state.current_customer
    },
    currentRestaurant(state) {
      return state.restaurant
    },
  },

  mutations: {
    update_cart(state, response) {
      if(response != "") {
        state.cart_items = response.attributes.order_items.data
        state.delivery_charges = response.attributes.delivery_charges
        state.cart_total = response.attributes.total
      } else {
        state.cart_items = []
      }
    },
    update_customer(state, customer) {
      state.current_customer = customer
    },
    update_auth_token(state, auth_token) {
      state.auth_token = auth_token
    },
    update_addresses(state, addresses) {
      state.current_customer.addresses = addresses
    },
    push_to_addresses(state, new_address) {
      state.current_customer.addresses.push(new_address)
    },
    setRestaurant(state, response) {
      state.restaurant = response.data.attributes
    }
  },

  actions: {
    add_to_cart({ commit }, cart) {
      client().post(`${api.carts()}.json`, cart)
        .then(response => {
          if($cookies.get('order_id') == null && this.getters.logged_in == false)
            Vue.$cookies.set('order_id', response.data.data.id);
          commit("update_cart", response.data.data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    load_cart_items({ commit }, params) {
      client().get(`${api.carts()}.json`, { params })
        .then(response => {
          if (response.data.data != null)
            commit("update_cart", response.data.data)
        })
    },
    remove_cart_item({ commit }, params) {
      client().delete(`${api.carts()}.json`, { params })
        .then(response => {
          commit("update_cart", response.data.data)
        })
    },
    update_cart_item({ commit }, cart) {
      client().put(`${api.carts()}.json`, cart)
        .then(response => {
          commit("update_cart", response.data.data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    place_order({ commit }, cart) {
      client().put(`${api.carts()}.json`, cart)
        .then(response => {
          commit("update_cart", '');
        })
        .catch(error => {
          console.log(error)
        })
    },
    create_session({ commit }, params) {
      return new Promise((resolve, reject) => {
        client().post(`${api.session()}.json`, params)
          .then(response => {
            commit('update_customer', {
              id: response.data.data.attributes.id,
              name: response.data.data.attributes.name,
              email: response.data.data.attributes.email,
              contact: response.data.data.attributes.contact,
              addresses: response.data.data.attributes.addresses,
            })
            set_auth_token(response.data.data.attributes.auth_token)
            commit('update_auth_token', response.data.data.attributes.auth_token)
            resolve(response.data)
          })
          .catch(error => {
            reject(error);
          })
      });
    },
    destroy_session({ commit }) {
      commit('update_customer', {
        id: "",
        name: "",
        email: "",
        contact: "",
        addresses: [],
      })
      commit('update_auth_token', null)
      commit('update_cart', '')
      remove_auth_token()
    },
    customer_signup({ commit }, customer) {
      return new Promise((resolve, reject) => {
        client().post(api.profiles(), { customer })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    load_addresses({ commit }) {
      return new Promise((resolve, reject) => {
        client().get(`${api.addresses()}.json`)
          .then(response => {
            commit("update_addresses", response.data.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      });
    },
    show_profile({ commit }) {
      return new Promise((resolve, reject) => {
        client().get(`${api.profiles()}.json`)
          .then(response => {
            commit("update_customer", {
              id: response.data.data.attributes.id,
              name: response.data.data.attributes.name,
              email: response.data.data.attributes.email,
              contact: response.data.data.attributes.contact,
              addresses: response.data.data.attributes.addresses,
            })
            resolve(response.data)
          })
          .catch(error => {
            reject(error);
          })
      });
    },
    update_profile({ commit }, customer) {
      return new Promise((resolve, reject) => {
        client().put(`${api.profiles()}.json`, { customer })
          .then(response => {
            commit('update_customer',{
              id: response.data.data.attributes.id,
              name: response.data.data.attributes.name,
              email: response.data.data.attributes.email,
              contact: response.data.data.attributes.contact,
              addresses: response.data.data.attributes.addresses,
            })
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    create_address({ commit }, address) {
      return new Promise((resolve, reject) => {
        client().post(api.addresses(), address)
          .then(response => {
            commit('push_to_addresses', response.data.data)
            resolve(response.data.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    remove_address({ commit }, address_id) {
      return new Promise((resolve, reject) => {
        client().delete(`${api.addresses()}/${address_id}.json`)
        .then(response => {
          commit('update_addresses', response.data.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
      })
    },
    getRestaurant({ commit }) {
      return new Promise((resolve, reject) => {
        client().get(api.restaurant())
          .then(response => {
            commit('setRestaurant', response.data)
            resolve(response.data)
          })
          .catch(error => reject(error.response))
      });
    },
  },

  modules: {},

  plugins: [createPersistedState()]
});

function set_auth_token(auth_token) {
  localStorage.setItem(AUTH_TOKEN, auth_token);
}
function remove_auth_token() {
  localStorage.removeItem(AUTH_TOKEN);
}
